import styled from "styled-components";

export const Container = styled.main`
  min-height: 100vh;
  background-color: #883098;
  padding: 4rem;

  /* #region MOBILE */
  /* 48rem é o equivalente a 768px */
  @media (max-width: 48rem) {
    padding: 1rem;
  }
  /* #endregion MOBILE */
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 0.5rem;
  padding: 2.125rem;
  box-shadow: 0 0.625rem 2.5rem rgba(0, 0, 0, 0.2);

  /* #region MOBILE */
  /* 48rem é o equivalente a 768px */
  @media (max-width: 48rem) {
    padding: 1rem;
    border-radius: 0.5;
  }
  /* #endregion MOBILE */
`;

export const Title = styled.h2`
  text-align: left;
  color: #4a4a4a;
  font-size: 28px;
  font-weight: 500;
  margin: 1rem 0 2.125rem 0;
  /* #region MOBILE */
  /* 48rem é o equivalente a 768px */
  @media (max-width: 48rem) {
    text-align: center;
    font-size: 24px;
    margin: 0.625rem 0 1.25rem 0;
  }
  /* #endregion MOBILE */
`;

export const Divider = styled.div`
  /* #region MOBILE */
  /* 48rem é o equivalente a 768px */
  @media (max-width: 48rem) {
    height: 0.125rem;
    background-color: #883098;
    margin-bottom: 1.25rem;
  }
  /* #endregion MOBILE */
`;

export const TableContainer = styled.section`
  /* #region MOBILE */
  /* 48rem é o equivalente a 768px */
  @media (max-width: 48rem) {
    display: none;
  }
  /* #endregion MOBILE */
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  th {
    text-align: left;
    padding: 1rem 1.25rem;
    color: #4a4a4a;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 0.125rem solid #883098;
  }
`;

export const TableBody = styled.tbody`
  tr {
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #f8f4fa;
    }

    &:not(:last-child) {
      border-bottom: 0.063rem solid #dadada;
    }
  }

  td {
    padding: 1.125rem 1.25rem;
    color: #000000;
    font-size: 15px;
  }
`;

export const MobileContainer = styled.section`
  display: none;

  /* #region MOBILE */
  /* 48rem é o equivalente a 768px */
  @media (max-width: 48rem) {
    display: block;
  }
  /* #endregion MOBILE */
`;

export const TrackingCard = styled.div`
  background: #fafafa;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 15px;
  border-left: 0.25rem solid #8b4f9e;
  border-bottom: 0.063rem solid #dadada;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.span`
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
`;

export const Value = styled.span`
  color: #000000;
  font-size: 16px;
  display: block;
  text-align: ${(props) => props.align || "left"};
`;
